import loadable from '@loadable/component';
import checkoutRoutes from './index';
import DefaultLayout from '../../layouts/DefaultLayout';
import CheckoutLayout from '../../layouts/CheckoutLayout';
import { RouteDefinition } from '../routes.types';
const {
  address,
  delivery,
  review,
  payment,
  response,
  success,
  pending,
} = checkoutRoutes;

const Address = loadable(
  () => import(/* webpackChunkName: "checkout" */ '@app/components/Address')
);
const Delivery = loadable(
  () => import(/* webpackChunkName: "checkout" */ '@app/components/Delivery')
);
const Review = loadable(
  () => import(/* webpackChunkName: "checkout" */ '@app/components/Review')
);
const Payment = loadable(
  () => import(/* webpackChunkName: "checkout" */ '@app/components/Payment')
);
const Response = loadable(
  () => import(/* webpackChunkName: "checkout" */ '@app/components/Response')
);
const Success = loadable(
  () => import(/* webpackChunkName: "checkout" */ '@app/components/Success')
);
const Pending = loadable(
  () => import(/* webpackChunkName: "checkout" */ '@app/components/Pending')
);

export const CHECKOUT_STEPS_ROUTES = {
  address: {
    ...address,
    component: Address,
  },
  delivery: {
    ...delivery,
    component: Delivery,
  },
  review: {
    ...review,
    component: Review,
  },
  payment: {
    ...payment,
    component: Payment,
  },
  response: {
    ...response,
    component: Response,
    layout: DefaultLayout,
  },
  success: {
    ...success,
    component: Success,
    layout: DefaultLayout,
  },
  pending: {
    ...pending,
    component: Pending,
    layout: DefaultLayout,
  },
};

const routes: RouteDefinition[] = [
  // For now redirect the root page to the address screen
  // (start of checkout process)
  {
    path: `/:language`,
    exact: true,
    redirect: CHECKOUT_STEPS_ROUTES.address.path,
  },
  {
    path: `/:language/checkout`,
    exact: true,
    redirect: CHECKOUT_STEPS_ROUTES.address.path,
  },
  ...Object.keys(CHECKOUT_STEPS_ROUTES).map((route) => ({
    ...CHECKOUT_STEPS_ROUTES[route],
    layout: CHECKOUT_STEPS_ROUTES[route].layout || CheckoutLayout,
  })),
];

export default routes;
